import type { VenueId } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';

export interface FlockProps
    extends CommonProps,
        VariantProps<typeof FlockStyles> {
    venue: VenueId;
}

export const FlockStyles = cva('-z-1 absolute translate-x-[-100%]');

export const Flock = ({
    className,
    venue,
    testId = 'flock',
}: FlockProps): JSX.Element => {
    return (
        <img
            alt=""
            className={twMerge(FlockStyles({ className }))}
            data-testid={testId}
            src={`/assets/${venue}/flock/flock.svg`}
        />
    );
};
